import { isAppTypeMpSklad } from './isAppTypeMpSklad'

/** MpCard frontend build. Inverse of {@link isAppTypeMpSklad}. */
export const isAppTypeMpCard = () => !isAppTypeMpSklad()
